import React from 'react';

export class HomeIcon extends React.PureComponent {
  render() {
    return (
      <svg width="26" height="23" viewBox="0 0 26 23" {...this.props}>
        <g fill="none" fillRule="evenodd">
          <path d="M-7-8h39.89v40H-7z" />
          <path
            d="M25.096 8.939l-2.948-2.024V1.737c0-.4-.323-.724-.721-.724h-3.513a.722.722 0 0 0-.721.724v1.777L13.357.878a.72.72 0 0 0-.82 0L.794 8.938a.725.725 0 0 0 .408 1.32c.14 0 .283-.04.407-.126l2.134-1.464v12.801c0 .4.323.723.721.723h16.964a.722.722 0 0 0 .72-.723V8.668l2.135 1.464a.716.716 0 0 0 1.002-.188.724.724 0 0 0-.188-1.005zM14.442 20.746h-2.994v-7.033h2.994v7.033zm6.264 0h-4.821V12.99c0-.4-.323-.723-.722-.723h-4.436a.722.722 0 0 0-.722.723v7.756h-4.82V7.678l7.76-5.327 7.76 5.327v13.068zm0-14.821l-2.07-1.421V2.46h2.07v3.465z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </svg>
    );
  }
}
